import { DirectiveType } from 'components/directive/utils/types'
import { EitherUserDirectiveResponse } from 'logic/directive/types'

export function extractDirectiveName(type: DirectiveType, data: EitherUserDirectiveResponse) {
  return type === 'TRUST' && data != null && 'trust' in data
    ? data.trust?.trust_name ?? data.trust?.formatted_trust_name
    : undefined
}
